/**
 * 运行配置：
 * - VITE_API_BASE 未设置 → 使用内置 mock（P1 默认，不依赖后端）
 * - VITE_API_BASE=/api/v1 或 https://host/api/v1 → 真后端
 */
export interface AppConfig {
  apiBase: string;
  mock: boolean;
}

export function readConfig(env: Record<string, string | undefined> = import.meta.env): AppConfig {
  const base = env.VITE_API_BASE?.trim();
  return base ? { apiBase: base.replace(/\/$/, ""), mock: false } : { apiBase: "/api/v1", mock: true };
}

export function wsUrlFor(apiBase: string, origin = typeof location === "undefined" ? "http://localhost" : location.origin): string {
  const u = new URL(`${apiBase}/ws`, origin);
  u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
  return u.toString();
}
